import { render } from "./appNavbar.vue?vue&type=template&id=4b271ba6&scoped=true"
import script from "./appNavbar.vue?vue&type=script&lang=js"
export * from "./appNavbar.vue?vue&type=script&lang=js"

import "./appNavbar.vue?vue&type=style&index=0&id=4b271ba6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b271ba6"]])

export default __exports__